import React from "react";

const NeutralStudentFilled = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24">
        <g fill={color} fillRule="nonzero">
            <path
                className="prefix__cls-1"
                d="M21.85 17.46l-3.77-1.05-1.39-.41a10.84 10.84 0 01-.87.8l1.16.31-4.48 4.51L8 17.15l1.16-.32a9.26 9.26 0 01-.86-.8l-1.38.39-3.82 1a4.67 4.67 0 00-3 4.35v2.63a.5.5 0 00.5.5h23.8a.5.5 0 00.5-.5v-2.58a4.66 4.66 0 00-3.05-4.36zM12.76 6.21a1.14 1.14 0 01-.52 0l-5.42-.94v1a.51.51 0 00.18.37c.07.07 1.74 1.7 5.53 1.7S18 6.71 18 6.64a.51.51 0 00.15-.35v-1z"
            />
            <path
                className="prefix__cls-1"
                d="M12.5 9.34A9.8 9.8 0 016.82 7.8V11c0 3.46 3.91 6.71 5.68 6.71s5.68-3.25 5.68-6.71V7.8a9.8 9.8 0 01-5.68 1.54z"
            />
            <path
                className="prefix__cls-1"
                d="M12.5 8.34C8.71 8.34 7 6.71 7 6.64v-.07.07c0 .07 1.71 1.7 5.5 1.7z"
            />
            <path
                className="prefix__cls-1"
                d="M24.49 2.18L12.59.11h-.18L.51 2.18a.49.49 0 00-.41.49.49.49 0 00.41.49l2.17.38v3.22L1.14 14a.53.53 0 00.1.42.53.53 0 00.39.18h3.11a.53.53 0 00.39-.18.53.53 0 00.1-.42L3.68 6.76v-3l8.73 1.52h.18l11.9-2.07a.49.49 0 00.41-.49.49.49 0 00-.41-.54z"
            />
        </g>
    </svg>
);

export default NeutralStudentFilled;
